import SDButtonGroup from '@/shared/components/SDComponentsNewDesign/SDButtonGroup/SDButtonGroup'
import ModuleHeader from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeader'
import ModuleHeading from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeading'
import ModuleToggle from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleToggle'
import useModuleCollapse from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/useModuleCollapse'
import {
  ModuleBody,
  ModuleContent,
} from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/styled-components'
import IconCarbonScript from '@/shared/icons/IconCarbonScript'
import SalesScriptContent from './SalesScriptContent'
import useSalesScript from './useSalesScript'
import { StyledContainer } from './styled-components'

const SalesScript = () => {
  const { hidden, title, emptyText, errorText, sectionOptions, selectedSection, content, status, selectSection } =
    useSalesScript()
  const { expanded, toggle } = useModuleCollapse('sales-script')

  if (hidden) return null

  return (
    <StyledContainer>
      <ModuleHeader clickable onClick={toggle}>
        <ModuleHeading icon={IconCarbonScript} moduleKey='sales-script'>
          {title}
        </ModuleHeading>
        <ModuleToggle expanded={expanded} onToggle={toggle} moduleKey='sales-script' />
      </ModuleHeader>
      <ModuleContent hidden={!expanded}>
        <ModuleBody>
          {/* @ts-expect-error SDButtonGroup is a JS component */}
          <SDButtonGroup
            options={sectionOptions}
            selectedValue={selectedSection}
            onClickHandler={selectSection}
          />
          <SalesScriptContent
            content={content}
            status={status}
            emptyText={emptyText}
            errorText={errorText}
          />
        </ModuleBody>
      </ModuleContent>
    </StyledContainer>
  )
}

export default SalesScript
